export default {
    props: {
        messagesStartLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.startLabel'
        }, 
        messagesEndLabel: {
            type: String,
            default: undefined,
            kComposite: 'messages.endLabel'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/Messages.js